(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-collection-text"] && !Shopify.designMode) return;
  try {
    
  customElements.define('isun-collection-text', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('toggle', (event) => {
        if (event.target.matches('.isun-collection-text__details') && event.target.open) {
          this.querySelector('.isun-collection-text__remainder').focus({ preventScroll: true });
        }
      }, true);
      this.addEventListener('click', (event) => {
        if (!event.target.closest('.isun-collection-text__close')) return;
        const details = this.querySelector('details');
        const summary = details.querySelector('summary');
        details.open = false;
        summary.focus({ preventScroll: true });
        summary.scrollIntoView({ block: 'center' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-native-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.isun-native-reviews img.jdgm-carousel-item__product-image';

    const showImageLabel = (image) => {
      if (!image.matches(selector) || image.dataset.isunImageFallback) return;
      image.dataset.isunImageFallback = 'true';
      const label = document.createElement('span');
      label.className = 'isun-native-reviews__image-label';
      label.textContent = image.alt;
      image.hidden = true;
      image.style.display = 'none';
      image.insertAdjacentElement('afterend', label);
    };

    document.addEventListener('error', (event) => {
      if (event.target instanceof HTMLImageElement) showImageLabel(event.target);
    }, true);

    const inspectLoadedImages = (root) => {
      root.querySelectorAll(selector).forEach((image) => {
        if (image.getAttribute('src') && image.complete && image.naturalWidth === 0) {
          showImageLabel(image);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => inspectLoadedImages(document), { once: true });
    } else {
      inspectLoadedImages(document);
    }

    document.addEventListener('shopify:section:load', (event) => inspectLoadedImages(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-ritual-builder"] && !Shopify.designMode) return;
  try {
    
  const ritualAvailabilityProducts = new Map();
  const ritualId = (value) => String(value || '').split('/').pop();

  const loadRitualAvailabilityProduct = (handle) => {
    if (!ritualAvailabilityProducts.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      ritualAvailabilityProducts.set(handle, fetch(`${root}products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : null)
        .catch(() => null));
    }
    return ritualAvailabilityProducts.get(handle);
  };

  const ritualConfiguredSteps = (ritual) => {
    const bundle = window.fgData?.bundles?.find((entry) => entry.type === 'bundle_product_page' &&
      ritualId(entry.extra_info?.product_bundle_id) === ritual.dataset.ritualProductId);
    return bundle?.products?.find((entry) => entry.type === 'config')?.value?.steps || [];
  };

  const ritualUnavailableReference = (ritual, productId) => ritual.ritualAvailability?.steps
    .flatMap((step) => step.products)
    .find((product) => product.id === String(productId) && product.available === false);

  const createRitualUnavailableCard = (ritual, product, stepTitle, index) => {
    const card = document.createElement('article');
    card.className = 'isun-ritual__sold-out-card';
    card.dataset.isunUnavailableProduct = product.id;
    card.dataset.productHandle = product.handle;
    const image = document.createElement('img');
    image.className = 'isun-ritual__sold-out-image';
    image.src = product.image;
    image.alt = product.title;
    image.width = 212;
    image.height = 212;
    image.loading = 'lazy';
    const content = document.createElement('div');
    content.className = 'isun-ritual__sold-out-content';
    const step = document.createElement('div');
    step.className = 'isun-ritual__card-step';
    step.textContent = `${index + 1}. ${stepTitle}`;
    const name = document.createElement('a');
    name.className = 'isun-ritual__sold-out-name';
    name.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.handle)}`;
    name.textContent = product.title;
    const variant = document.createElement('span');
    variant.className = 'isun-ritual__sold-out-variant';
    variant.textContent = product.variantTitle === 'Default Title' ? '' : product.variantTitle;
    const label = document.createElement('span');
    label.className = 'isun-ritual__sold-out-label';
    label.textContent = ritual.dataset.soldOutLabel;
    content.append(step, name, variant, label);
    card.append(image, content);
    return card;
  };

  const synchronizeRitualAvailability = (ritual, refresh) => {
    if (!ritual.ritualAvailability) {
      const steps = ritualConfiguredSteps(ritual);
      if (!steps.length) return false;
      ritual.ritualAvailability = { steps: [], loaded: false };
      Promise.all(steps.map(async (step) => {
        const references = step.selected?.type === 'variants_ids' && Array.isArray(step.selected.value) ? step.selected.value : [];
        const products = await Promise.all((references || []).map(async (reference) => {
          const data = await loadRitualAvailabilityProduct(reference.handle);
          const id = ritualId(reference.id);
          const ids = (reference.variants || []).map((variant) => ritualId(variant.id))
            .filter((variantId) => id !== ritual.dataset.fixedProductId || variantId === ritual.dataset.fixedVariantId);
          const variants = data?.variants?.filter((variant) => ids.includes(String(variant.id))) || [];
          const complete = variants.length === ids.length && ids.length > 0 && variants.every((entry) => typeof entry.available === 'boolean');
          const variant = variants[0];
          return {
            id, handle: reference.handle,
            title: data?.title || reference.title,
            image: variant?.featured_image?.src || data?.featured_image || reference.images?.[0]?.originalSrc || '',
            variantTitle: variant?.title || reference.variants?.[0]?.title || '',
            available: complete ? variants.some((entry) => entry.available) : null
          };
        }));
        return { id: String(step.id), title: step.title, products, supported: references.length > 0 };
      })).then((resolved) => {
        ritual.ritualAvailability = { steps: resolved, loaded: true };
        refresh();
      });
      return false;
    }
    if (!ritual.ritualAvailability.loaded) return false;
    let ready = true;
    ritual.ritualAvailability.steps.forEach((configuredStep, index) => {
      const step = [...ritual.querySelectorAll('.bogos-bundle-pp-step')]
        .find((entry) => entry.dataset.stepId === configuredStep.id);
      if (!step) { ready = false; return; }
      const container = step.querySelector('.bogos-bundle-pp-step-items');
      if (!container) { ready = false; return; }
      if (!configuredStep.supported) {
        if (!step.querySelector('.bogos-bundle-pp-item[data-qty]')) ready = false;
        return;
      }
      configuredStep.products.forEach((product) => {
        const native = [...step.querySelectorAll('.bogos-bundle-pp-item[data-product-id]')]
          .filter((item) => item.dataset.productId === product.id);
        const fallback = [...container.querySelectorAll('[data-isun-unavailable-product]')]
          .find((item) => item.dataset.isunUnavailableProduct === product.id);
        if (product.available === false) {
          native.forEach((item) => {
            if (Number(item.dataset.qty) > 0) {
              const selecting = ritual.ritualIsAutoSelecting;
              ritual.ritualIsAutoSelecting = true;
              item.querySelector('.bogos-bundle-pp-minus')?.click();
              ritual.ritualIsAutoSelecting = selecting;
              if (Number(item.dataset.qty) > 0) ready = false;
            }
            if (item.dataset.isunUnavailable !== 'true') item.dataset.isunUnavailable = 'true';
          });
          if (!fallback) container.append(createRitualUnavailableCard(ritual, product,
            step.querySelector('.bogos-bundle-pp-step-title')?.textContent.trim() || configuredStep.title, index));
        } else {
          fallback?.remove();
          if (!native.length || product.available === null) ready = false;
        }
      });
    });
    if (ritual.dataset.isunAvailabilityReady !== String(ready)) ritual.dataset.isunAvailabilityReady = String(ready);
    return ready;
  };

  const updateRitualAvailabilityStatus = (ritual) => {
    const ready = ritual.dataset.isunAvailabilityReady === 'true';
    const products = ritual.ritualAvailability?.steps.flatMap((step) => step.products) || [];
    const soldOut = products.some((product) => product.available === false);
    const available = [...ritual.querySelectorAll('.bogos-bundle-pp-step')].flatMap(availableBogosItems);
    const allSoldOut = ready && available.length === 0;
    const note = ritual.querySelector('[data-isun-availability-note]');
    const unsafeSelection = [...ritual.querySelectorAll('.bogos-bundle-pp-item[data-isun-unavailable="true"]')].some((item) => Number(item.dataset.qty) > 0);
    const message = unsafeSelection || products.some((product) => product.available === null) ? ritual.dataset.availabilityErrorLabel : allSoldOut ? ritual.dataset.allSoldOutLabel : soldOut ? ritual.dataset.partialRitualLabel : '';
    if (note && note.textContent !== message) note.textContent = message;
    if (note && note.hidden !== !message) note.hidden = !message;
    const total = ritual.querySelector('.bogos-bundle-pp-total-label');
    if (total && total.textContent !== ritual.dataset.selectedTotalLabel) total.textContent = ritual.dataset.selectedTotalLabel;
    const button = ritual.querySelector('.bogos-bundle-pp-btn-add');
    if (button && (allSoldOut || unsafeSelection)) button.disabled = true;
    const totalPrice = ritual.querySelector('.bogos-bundle-pp-total');
    if (totalPrice && totalPrice.hidden !== unsafeSelection) totalPrice.hidden = unsafeSelection;
    const stepSection = document.querySelector('[data-isun-ritual-steps-section]');
    const completeButton = stepSection?.querySelector('[data-isun-buy-ritual]');
    if (completeButton && completeButton.getAttribute('aria-busy') !== 'true') {
      completeButton.disabled = !ready || allSoldOut;
      const text = completeButton.querySelector('span');
      if (text) {
        if (!text.dataset.originalLabel) text.dataset.originalLabel = text.textContent;
        const label = allSoldOut ? ritual.dataset.soldOutLabel : soldOut ? ritual.dataset.buyAvailableLabel : text.dataset.originalLabel;
        if (text.textContent !== label) text.textContent = label;
      }
    }
    const prompt = stepSection?.querySelector('[data-isun-complete-prompt]');
    if (prompt) {
      if (!prompt.dataset.originalLabel) prompt.dataset.originalLabel = prompt.textContent;
      const label = allSoldOut ? ritual.dataset.allSoldOutLabel : soldOut ? ritual.dataset.partialRitualLabel : prompt.dataset.originalLabel;
      if (prompt.textContent !== label) prompt.textContent = label;
    }
  };

  const guardRitualAvailability = (ritual, event) => {
    const item = event.target.closest('.bogos-bundle-pp-item');
    const add = event.target.closest('.bogos-bundle-pp-btn-add');
    const unsafeSelection = [...ritual.querySelectorAll('.bogos-bundle-pp-item[data-isun-unavailable="true"]')]
      .some((entry) => Number(entry.dataset.qty) > 0);
    if ((item?.dataset.isunUnavailable === 'true' && !event.target.closest('.bogos-bundle-pp-minus')) || (add &&
        (ritual.dataset.isunAvailabilityReady !== 'true' || unsafeSelection ||
        ![...ritual.querySelectorAll('.bogos-bundle-pp-step')].flatMap(availableBogosItems).some((entry) => Number(entry.dataset.qty) > 0)))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  const ritualProductData = new Map();

  const fetchRitualProductData = (handle) => {
    if (!ritualProductData.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}products/${encodeURIComponent(handle)}?view=ritual-data`;
      ritualProductData.set(handle, fetch(url, { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : null)
        .catch(() => null));
    }
    return ritualProductData.get(handle);
  };

  const conciseCardDescription = (data) => {
    const source = data?.description || '';
    const clean = source.replace(/<[^>]*>/g, ' ').replace(/^[\s•*\-–—]+/, '').replace(/\s+/g, ' ').trim();
    if (!clean) return '';
    const sentence = clean.match(/^.*?[.!?](?:\s|$)/)?.[0] || clean;
    return sentence.length > 155 ? `${sentence.slice(0, 152).trim()}…` : sentence;
  };

  const selectedRitualItemCount = (ritual) => [...ritual.querySelectorAll('.bogos-bundle-pp-item[data-qty]')]
    .reduce((total, item) => total + (Number.parseInt(item.dataset.qty, 10) || 0), 0);

  const completeRitualCartAdd = (ritual) => {
    const pending = ritual.ritualCartPending;
    if (!pending) return;
    ritual.ritualCartPending = null;
    window.clearTimeout(pending.timeout);
    pending.button.removeAttribute('aria-busy');
    if (pending.externalButton) {
      pending.externalButton.disabled = false;
      pending.externalButton.removeAttribute('aria-busy');
    }
    if (pending.status) pending.status.textContent = '';
    const drawer = document.querySelector('.js-cart-drawer');
    const openDrawer = () => {
      if (typeof drawer?.open === 'function') {
        drawer.open(pending.button);
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
          bubbles: true,
          cancelable: false,
          detail: { opener: pending.button }
        }));
      }
    };
    document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
    openDrawer();
  };

  const monitorRitualCartAdd = (ritual) => {
    const pending = ritual.ritualCartPending;
    if (!pending) return;
    const addConfirmed = [...ritual.querySelectorAll('.bogos-bn-status')]
      .some((status) => status.textContent.trim().toLowerCase() === 'added to cart');
    if (pending.selectedCount > 0 && selectedRitualItemCount(ritual) === 0 && addConfirmed) {
      completeRitualCartAdd(ritual);
    }
  };

  const resetCompleteRitualButton = (button, status, message = '') => {
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
    if (status) status.textContent = message;
  };

  const availableBogosItems = (step) => [...step.querySelectorAll('.bogos-bundle-pp-item[data-qty]')]
    .filter((item) => item.dataset.isunUnavailable !== 'true' && item.dataset.available !== '0' && !item.hidden && getComputedStyle(item).display !== 'none');

  const preselectRitualProducts = (ritual) => {
    if (ritual.ritualInitialSelectionComplete || ritual.ritualCustomerCustomized) return;
    const steps = [...ritual.querySelectorAll('.bogos-bundle-pp-step')];
    if (!steps.length || ritual.dataset.isunAvailabilityReady !== 'true') return;
    const available = steps.flatMap(availableBogosItems);
    if (!available.length) return;
    ritual.ritualIsAutoSelecting = true;
    available.forEach((item) => {
      if ((Number.parseInt(item.dataset.qty, 10) || 0) > 0) return;
      const selectButton = item.querySelector('.bogos-bundle-pp-add-btn');
      if (selectButton && !selectButton.disabled) selectButton.click();
    });
    ritual.ritualIsAutoSelecting = false;
    ritual.ritualInitialSelectionComplete = true;
  };

  const completeRitualChoice = (step) => {
    const available = availableBogosItems(step);
    const selected = available.filter((item) => (Number.parseInt(item.dataset.qty, 10) || 0) > 0);
    if (selected.length === 1) return selected[0];
    if (selected.length > 1) return null;
    const explicit = available.filter((item) => item.matches('.is-active, .active, .selected, [aria-selected="true"], [aria-pressed="true"], [data-selected="true"]'));
    if (explicit.length === 1) return explicit[0];
    return available.length === 1 ? available[0] : null;
  };

  const waitForCompleteRitualSelection = (ritual, choices, button, status) => {
    const startedAt = Date.now();
    const check = () => {
      const ready = choices.every((item) => (Number.parseInt(item.dataset.qty, 10) || 0) > 0);
      const cartButton = ritual.querySelector('.bogos-bundle-pp-btn-add');
      if (ready && cartButton && !cartButton.disabled && cartButton.getAttribute('aria-disabled') !== 'true') {
        ritual.ritualExternalTrigger = { button, status };
        cartButton.click();
        const submittedAt = Date.now();
        const confirm = () => {
          const added = [...ritual.querySelectorAll('.bogos-bn-status')]
            .some((message) => message.textContent.trim().toLowerCase() === 'added to cart');
          if (added && selectedRitualItemCount(ritual) === 0) {
            resetCompleteRitualButton(button, status);
            ritual.ritualExternalTrigger = null;
            return;
          }
          if (Date.now() - submittedAt > 15000) {
            resetCompleteRitualButton(button, status, 'The ritual was not added. Please try again.');
            ritual.ritualExternalTrigger = null;
            return;
          }
          requestAnimationFrame(confirm);
        };
        confirm();
        return;
      }
      if (Date.now() - startedAt > 8000) {
        resetCompleteRitualButton(button, status, 'The complete ritual could not be selected. Please review the builder above.');
        return;
      }
      requestAnimationFrame(check);
    };
    check();
  };

  document.addEventListener('isun:ritual:buy-complete', (event) => {
    const ritual = document.querySelector('.isun-ritual');
    const button = event.detail?.button;
    const status = event.detail?.status;
    if (!ritual || ritual.ritualCartPending) {
      resetCompleteRitualButton(button, status, 'The ritual builder is not ready yet. Please try again.');
      return;
    }
    if (ritual.dataset.isunAvailabilityReady !== 'true') {
      resetCompleteRitualButton(button, status, ritual.dataset.availabilityErrorLabel);
      return;
    }
    const steps = [...ritual.querySelectorAll('.bogos-bundle-pp-step')];
    const purchasableSteps = steps.filter((step) => availableBogosItems(step).length > 0);
    const choices = purchasableSteps.map(completeRitualChoice);
    if (!purchasableSteps.length) {
      resetCompleteRitualButton(button, status, 'This ritual is currently unavailable.');
      return;
    }
    if (choices.some((choice) => !choice)) {
      resetCompleteRitualButton(button, status, 'Please choose an option in each multi-choice ritual step above.');
      return;
    }
    choices.forEach((item) => {
      if ((Number.parseInt(item.dataset.qty, 10) || 0) > 0) return;
      const selectButton = item.querySelector('.bogos-bundle-pp-add-btn');
      if (selectButton && !selectButton.disabled) selectButton.click();
    });
    waitForCompleteRitualSelection(ritual, choices, button, status);
  });

  const updateWeightedReviews = async (ritual) => {
    const handles = [...new Set([...ritual.querySelectorAll('.bogos-bundle-pp-item[data-product-handle]')]
      .map((item) => item.dataset.productHandle)
      .filter(Boolean))];
    if (!handles.length) return;
    const data = (await Promise.all(handles.map(fetchRitualProductData))).filter(Boolean);
    const reviewed = data.filter((item) => Number(item.reviewCount) > 0 && Number(item.rating) > 0);
    const reviewCount = reviewed.reduce((sum, item) => sum + Number(item.reviewCount), 0);
    if (!reviewCount) return;
    const rating = reviewed.reduce((sum, item) => sum + (Number(item.rating) * Number(item.reviewCount)), 0) / reviewCount;
    const output = ritual.querySelector('[data-isun-weighted-reviews]');
    if (!output) return;
    output.querySelector('[data-isun-review-stars]').style.width = `${(rating / 5) * 100}%`;
    output.querySelector('[data-isun-review-label]').textContent = `${rating.toFixed(1)} · ${reviewCount} ${ritual.dataset.reviewLabel}`;
    output.setAttribute('aria-label', `${rating.toFixed(1)} out of 5, ${reviewCount} ${ritual.dataset.reviewLabel}`);
    output.hidden = false;
    ritual.classList.add('has-weighted-reviews');
  };

  const updateRitualLabels = (ritual) => {
    const currency = window.Shopify?.currency?.active || ritual.dataset.currencyCode;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 2
    });
    ritual.querySelectorAll('.bogos-bundle-pp-item[data-price]').forEach((item) => {
      const amount = Number(item.dataset.price);
      if (!Number.isFinite(amount)) return;
      const formatted = formatter.format(amount);
      if (item.dataset.formattedPrice !== formatted) item.dataset.formattedPrice = formatted;
    });
    const totalLabel = ritual.querySelector('.bogos-bundle-pp-total-label');
    if (totalLabel && totalLabel.textContent !== ritual.dataset.selectedTotalLabel) {
      totalLabel.textContent = ritual.dataset.selectedTotalLabel;
    }
    const basketButton = ritual.querySelector('.bogos-bundle-pp-btn-add');
    if (basketButton && !basketButton.classList.contains('bogos-bundles-adding') && basketButton.getAttribute('aria-busy') !== 'true') {
      if (basketButton.textContent !== ritual.dataset.addToBasketLabel) basketButton.textContent = ritual.dataset.addToBasketLabel;
    }
  };

  const arrangeRitualProducts = (ritual) => {
    const stepTitles = [...ritual.querySelectorAll('.bogos-bundle-pp-step-title')]
      .map((title) => title.textContent.trim())
      .filter(Boolean);
    const stepSummary = ritual.querySelector('[data-isun-ritual-steps]');
    if (stepSummary && stepTitles.length) {
      stepSummary.textContent = stepTitles.join(' • ');
      stepSummary.hidden = false;
    }

    ritual.querySelectorAll('.bogos-bundle-pp-item-info').forEach((info) => {
      const name = info.querySelector('.bogos-bundle-pp-item-name');
      const variant = info.querySelector('.bogos-bundle-pp-select-variant-wrapper');
      let line = info.querySelector(':scope > .isun-ritual__product-line');
      if (!line && name && variant) {
        name.title = name.textContent.trim();
        line = document.createElement('div');
        line.className = 'isun-ritual__product-line';
        info.insertBefore(line, name);
        line.append(name, variant);
      }
      if (!line) return;

      const step = info.closest('.bogos-bundle-pp-step');
      const rawStepTitle = step?.querySelector('.bogos-bundle-pp-step-title')?.textContent.trim();
      let cardStep = line.querySelector('.isun-ritual__card-step');
      if (rawStepTitle && !cardStep) {
        const steps = [...step.parentElement.children].filter((child) => child.classList.contains('bogos-bundle-pp-step'));
        cardStep = document.createElement('div');
        cardStep.className = 'isun-ritual__card-step';
        cardStep.textContent = `${steps.indexOf(step) + 1}. ${rawStepTitle}`;
        line.prepend(cardStep);
      }

      const productName = line.querySelector('.bogos-bundle-pp-item-name');
      let titleRow = productName?.querySelector('.isun-ritual__product-title-row');
      if (productName && !titleRow) {
        const title = productName.textContent.trim();
        productName.textContent = '';
        titleRow = document.createElement('span');
        titleRow.className = 'isun-ritual__product-title-row';
        const titleText = document.createElement('span');
        titleText.className = 'isun-ritual__product-title-text';
        titleText.textContent = title;
        titleRow.append(titleText);
        productName.append(titleRow);
      }

      const lineVariant = line.querySelector('.bogos-bundle-pp-select-variant-wrapper');
      const selected = lineVariant?.querySelector('.bogos-bundle-pp-select-variant-title')?.textContent.trim();
      const optionCount = lineVariant?.querySelectorAll('.bogos-bundle-pp-select-variant-option').length || 0;
      let inlineVariant = titleRow?.querySelector('.isun-ritual__variant-inline');
      const meaningfulVariant = selected && selected.toLowerCase() !== 'default title';
      if (meaningfulVariant && titleRow) {
        if (!inlineVariant) {
          inlineVariant = document.createElement('span');
          inlineVariant.className = 'isun-ritual__variant-inline';
          titleRow.append(inlineVariant);
        }
        inlineVariant.textContent = `(${selected})`;
      } else {
        inlineVariant?.remove();
      }
      lineVariant?.classList.toggle('is-single-variant', optionCount <= 1);

      const item = info.closest('.bogos-bundle-pp-item');
      const handle = item?.dataset.productHandle;
      if (handle && productName && !productName.querySelector('.isun-ritual__card-description')) {
        fetchRitualProductData(handle).then((data) => {
          const description = conciseCardDescription(data);
          if (!description || productName.querySelector('.isun-ritual__card-description')) return;
          const detail = document.createElement('span');
          detail.className = 'isun-ritual__card-description';
          detail.textContent = description;
          productName.append(detail);
        });
      }
    });
    updateWeightedReviews(ritual);
  };

  document.querySelectorAll('.isun-ritual').forEach((ritual) => {
    let scheduled = false;
    const refresh = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        synchronizeRitualAvailability(ritual, refresh);
        preselectRitualProducts(ritual);
        arrangeRitualProducts(ritual);
        updateRitualLabels(ritual);
        updateRitualAvailabilityStatus(ritual);
        monitorRitualCartAdd(ritual);
      });
    };
    ritual.addEventListener('click', (event) => guardRitualAvailability(ritual, event), true);
    ritual.addEventListener('click', (event) => {
      if (!ritual.ritualIsAutoSelecting && event.target.closest('.bogos-bundle-pp-add-btn, .bogos-bundle-pp-minus, .bogos-bundle-pp-plus, .bogos-bundle-pp-select-variant-option')) {
        ritual.ritualCustomerCustomized = true;
      }
    });
    refresh();
    const availabilityDeadline = Date.now() + 20000;
    const waitForAvailability = () => {
      refresh();
      if (ritual.dataset.isunAvailabilityReady !== 'true' && Date.now() < availabilityDeadline) window.setTimeout(waitForAvailability, 250);
    };
    waitForAvailability();
    const observer = new MutationObserver(refresh);
    const apps = ritual.querySelector('.isun-ritual__apps');
    if (apps) observer.observe(apps, { attributes: true, childList: true, characterData: true, subtree: true });
  });

  document.addEventListener('click', (event) => {
    const reviewTrigger = event.target.closest('[data-isun-ritual-reviews-trigger]');
    if (reviewTrigger) {
      const reviews = document.querySelector('[data-isun-ritual-reviews-section]');
      if (reviews && !reviews.hidden) {
        reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const heading = reviews.querySelector('[data-isun-ritual-reviews-heading]');
        window.setTimeout(() => heading?.focus({ preventScroll: true }), 500);
      }
      return;
    }

    const cartButton = event.target.closest('.isun-ritual .bogos-bundle-pp-btn-add');
    if (cartButton && !cartButton.disabled && cartButton.getAttribute('aria-disabled') !== 'true') {
      const ritual = cartButton.closest('.isun-ritual');
      const selectedCount = selectedRitualItemCount(ritual);
      if (selectedCount > 0) {
        if (ritual.ritualCartPending) window.clearTimeout(ritual.ritualCartPending.timeout);
        cartButton.setAttribute('aria-busy', 'true');
        const timeout = window.setTimeout(() => {
          if (!ritual.ritualCartPending) return;
          const pending = ritual.ritualCartPending;
          ritual.ritualCartPending = null;
          cartButton.removeAttribute('aria-busy');
          resetCompleteRitualButton(pending.externalButton, pending.status, 'The ritual was not added. Please try again.');
        }, 15000);
        const externalTrigger = ritual.ritualExternalTrigger;
        ritual.ritualExternalTrigger = null;
        ritual.ritualCartPending = {
          button: cartButton,
          selectedCount,
          timeout,
          externalButton: externalTrigger?.button,
          status: externalTrigger?.status
        };
      }
      return;
    }

    const button = event.target.closest('[data-isun-gallery-button]');
    if (!button) return;
    const gallery = button.closest('.isun-ritual__visual');
    if (!gallery) return;
    const selectedIndex = button.dataset.isunGalleryButton;
    gallery.querySelectorAll('[data-isun-gallery-media]').forEach((media) => {
      const isActive = media.dataset.isunGalleryMedia === selectedIndex;
      media.hidden = !isActive;
      media.classList.toggle('is-active', isActive);
    });
    gallery.querySelectorAll('[data-isun-gallery-button]').forEach((item) => {
      const isActive = item === button;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', String(isActive));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-ritual-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-isun-ritual-reviews-section]');
    const ritual = document.querySelector('.isun-ritual');
    if (!section || !ritual) return;

    const tabs = section.querySelector('[data-isun-review-tabs]');
    const productLabel = section.querySelector('[data-isun-review-product]');
    const widgetHost = section.querySelector('[data-isun-review-widget]');
    const products = new Map();
    const pendingHandles = new Set();
    let activeId = '';
    let refreshQueued = false;

    const productUrl = (handle) => {
      const root = window.Shopify?.routes?.root || '/';
      return `${root}products/${encodeURIComponent(handle)}?view=ritual-data`;
    };

    const normalizeReviewData = (product) => {
      let data = product.reviewWidgetData;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch (_) { data = null; }
      }
      if (!data || !Array.isArray(data.reviews)) {
        const source = document.createElement('template');
        source.innerHTML = typeof product.reviewWidgetHtml === 'string' ? product.reviewWidgetHtml : '';
        const widget = source.content.querySelector('.jdgm-rev-widg');
        if (!widget) return { ...product, reviewWidgetData: null };
        const reviews = [...widget.querySelectorAll('.jdgm-rev-widg__reviews > .jdgm-rev')].slice(0, 5).map((review) => {
          const body = review.querySelector('.jdgm-rev__body');
          const paragraphs = body ? [...body.querySelectorAll('p')] : [];
          const text = (node) => {
            const copy = node.cloneNode(true);
            copy.querySelectorAll('br').forEach((br) => br.replaceWith('\n'));
            return copy.textContent.trim();
          };
          return {
            id: review.dataset.reviewId,
            rating: Number(review.querySelector('.jdgm-rev__rating')?.dataset.score),
            reviewer_name: review.querySelector('.jdgm-rev__author')?.textContent.trim() || '',
            title: review.querySelector('.jdgm-rev__title')?.textContent.trim() || '',
            body: paragraphs.length ? paragraphs.map(text).join('\n\n') : (body ? text(body) : ''),
            created_at: review.querySelector('.jdgm-rev__timestamp')?.getAttribute('datetime') || '',
            verified_buyer: review.dataset.verifiedBuyer === 'true',
            product_title: product.title
          };
        }).filter((review) => review.id && Number.isInteger(review.rating) && review.rating >= 1 && review.rating <= 5);
        data = {
          number_of_reviews: Number(widget.dataset.numberOfReviews),
          average_rating: Number(widget.dataset.averageRating),
          reviews
        };
      }
      return { ...product, reviewCount: Number(data.number_of_reviews), reviewWidgetData: data };
    };

    const mountWidget = (product) => {
      activeId = String(product.id);
      tabs.querySelectorAll('[role="tab"]').forEach((tab) => {
        const active = tab.dataset.productId === activeId;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active) widgetHost.setAttribute('aria-labelledby', tab.id);
      });
      productLabel.textContent = `${section.dataset.productLabel}: ${product.title}`;
      widgetHost.replaceChildren();
      const data = product.reviewWidgetData;
      const summary = document.createElement('div');
      summary.className = 'isun-ritual-reviews__summary';
      const average = document.createElement('strong');
      average.textContent = `${Number(data.average_rating).toFixed(1)} ★`;
      const count = document.createElement('span');
      count.textContent = `${data.number_of_reviews} reviews`;
      summary.append(average, count);
      widgetHost.append(summary);

      const list = document.createElement('div');
      list.className = 'isun-ritual-reviews__list';
      const visibleReviews = (data.reviews || []).slice(0, 5);
      visibleReviews.forEach((review) => {
        const article = document.createElement('article');
        article.className = 'isun-ritual-reviews__card';
        if (review.id) article.dataset.reviewId = String(review.id);
        const stars = document.createElement('div');
        stars.className = 'isun-ritual-reviews__card-stars';
        stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
        stars.textContent = '★★★★★'.slice(0, review.rating);
        const meta = document.createElement('p');
        meta.className = 'isun-ritual-reviews__meta';
        const dateValue = review.created_at ? new Date(review.created_at) : null;
        const date = dateValue && !Number.isNaN(dateValue.getTime()) ? dateValue.toLocaleDateString(undefined, { timeZone: 'UTC', year: 'numeric', month: 'short', day: 'numeric' }) : '';
        meta.textContent = `${review.reviewer_name || 'Customer'}${review.verified_buyer ? ' · Verified' : ''}${date ? ` · ${date}` : ''}`;
        if (review.title) {
          const title = document.createElement('h3');
          title.textContent = review.title;
          article.append(stars, title, meta);
        } else {
          article.append(stars, meta);
        }
        const body = document.createElement('p');
        body.textContent = review.body || '';
        body.style.whiteSpace = 'pre-line';
        const association = document.createElement('p');
        association.className = 'isun-ritual-reviews__association';
        association.textContent = `${section.dataset.productLabel}: ${product.title}`;
        article.append(body, association);
        list.append(article);
      });
      widgetHost.append(list);

      if (Number(data.number_of_reviews) > visibleReviews.length) {
        const allReviews = document.createElement('a');
        allReviews.className = 'isun-ritual-reviews__all button button--secondary';
        allReviews.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(product.handle)}#judgeme_product_reviews`;
        allReviews.textContent = `View all ${data.number_of_reviews} reviews for ${product.title}`;
        widgetHost.append(allReviews);
      }
    };

    const render = () => {
      const reviewed = [...products.values()].filter((product) => Number(product.reviewCount) > 0 && product.reviewWidgetData?.reviews?.length);
      if (!reviewed.length) return;
      tabs.replaceChildren();
      reviewed.forEach((product, index) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'isun-ritual-reviews__tab';
        tab.setAttribute('role', 'tab');
        tab.id = `${section.id}-tab-${product.id}`;
        tab.setAttribute('aria-controls', widgetHost.id);
        tab.tabIndex = index === 0 ? 0 : -1;
        tab.setAttribute('aria-selected', String(index === 0));
        tab.dataset.productId = String(product.id);
        tab.textContent = product.title;
        tab.addEventListener('click', () => mountWidget(product));
        tabs.append(tab);
      });
      section.hidden = false;
      mountWidget(reviewed.find((product) => String(product.id) === activeId) || reviewed[0]);
    };

    tabs.addEventListener('keydown', (event) => {
      const allTabs = [...tabs.querySelectorAll('[role="tab"]')];
      const index = allTabs.indexOf(event.target);
      if (index < 0) return;
      let target;
      if (event.key === 'ArrowRight') target = allTabs[(index + 1) % allTabs.length];
      else if (event.key === 'ArrowLeft') target = allTabs[(index + allTabs.length - 1) % allTabs.length];
      else if (event.key === 'Home') target = allTabs[0];
      else if (event.key === 'End') target = allTabs[allTabs.length - 1];
      if (!target) return;
      event.preventDefault();
      target.focus();
      target.click();
    });

    const refresh = async () => {
      const handles = [...new Set([...ritual.querySelectorAll('.bogos-bundle-pp-item[data-product-handle]')]
        .map((item) => item.dataset.productHandle)
        .filter(Boolean))];
      const missing = handles.filter((handle) => !products.has(handle) && !pendingHandles.has(handle));
      if (!missing.length) return;
      missing.forEach((handle) => pendingHandles.add(handle));
      const results = await Promise.all(missing.map((handle) => fetch(productUrl(handle), { credentials: 'same-origin' })
        .then((response) => response.ok ? response.json() : null)
        .then((product) => product ? normalizeReviewData(product) : null)
        .catch(() => null)
        .finally(() => pendingHandles.delete(handle))));
      results.filter(Boolean).forEach((product) => products.set(product.handle, product));
      render();
    };

    const scheduleRefresh = () => {
      if (refreshQueued) return;
      refreshQueued = true;
      requestAnimationFrame(() => { refreshQueued = false; refresh(); });
    };
    scheduleRefresh();
    const observer = new MutationObserver(scheduleRefresh);
    const apps = ritual.querySelector('.isun-ritual__apps');
    if (apps) observer.observe(apps, { childList: true, subtree: true, attributes: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isun-ritual-steps"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const selectBogosProduct = (bogosStep) => {
        const products = [...bogosStep.querySelectorAll('.bogos-bundle-pp-item[data-product-handle]:not([data-isun-unavailable="true"]), [data-isun-unavailable-product]')];
        if (products.length < 2) return products[0] || null;
        return products.find((product) => product.matches('[data-qty]:not([data-qty="0"])'))
          || products.find((product) => !product.dataset.isunUnavailableProduct && !product.hidden && getComputedStyle(product).display !== 'none')
          || products[0];
      };

      const populateRitualSteps = (section) => {
        const builder = document.querySelector('.isun-ritual');
        const bogosSteps = builder ? [...builder.querySelectorAll('.bogos-bundle-pp-step')] : [];
        if (!bogosSteps.length) return false;

        let populatedCount = 0;
        section.querySelectorAll('[data-isun-ritual-step]').forEach((step, index) => {
          const bogosStep = bogosSteps[index];
          const product = bogosStep ? selectBogosProduct(bogosStep) : null;
          if (!product) return;

          const handle = product.dataset.productHandle;
          const sourceName = product.querySelector('.bogos-bundle-pp-item-name, .isun-ritual__sold-out-name');
          const title = sourceName?.title || sourceName?.querySelector('.isun-ritual__product-title-text')?.textContent.trim() || sourceName?.textContent.trim();
          const sourceImage = product.querySelector('.bogos-bundle-pp-item-img, .isun-ritual__sold-out-image');
          const productLink = step.querySelector('[data-isun-step-product]');
          const variantOutput = step.querySelector('[data-isun-step-variant]');
          const selectedVariant = product.querySelector('.bogos-bundle-pp-select-variant-title, .isun-ritual__sold-out-variant')?.textContent.trim();

          if (title && productLink) {
            productLink.textContent = title;
            if (handle) productLink.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}`;
            productLink.hidden = false;
          }

          if (variantOutput) {
            const value = selectedVariant && selectedVariant.toLowerCase() !== 'default title' ? selectedVariant : '';
            if (variantOutput.textContent !== value) variantOutput.textContent = value;
            variantOutput.hidden = !value;
          }
          const soldOut = step.querySelector('[data-isun-step-sold-out]');
          if (soldOut) soldOut.hidden = !product.dataset.isunUnavailableProduct;

          const visual = step.querySelector('[data-isun-step-visual].is-product-fallback');
          const existingImage = visual?.querySelector('img');
          if (visual && sourceImage && (!existingImage || visual.dataset.productHandle !== handle)) {
            visual.textContent = '';
            const image = sourceImage.cloneNode(true);
            image.className = 'isun-ritual-step__image is-product';
            image.loading = 'lazy';
            image.alt = title || '';
            if (handle) {
              const imageLink = document.createElement('a');
              imageLink.href = `${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}`;
              imageLink.setAttribute('aria-label', title || 'View product');
              imageLink.append(image);
              visual.append(imageLink);
            } else {
              visual.append(image);
            }
            visual.dataset.productHandle = handle || '';
          }
          populatedCount += 1;
        });
        return populatedCount > 0;
      };

      document.querySelectorAll('[data-isun-ritual-steps-section]').forEach((section) => {
        populateRitualSteps(section);
        const builderApps = document.querySelector('.isun-ritual__apps');
        if (!builderApps) return;
        const observer = new MutationObserver(() => populateRitualSteps(section));
        observer.observe(builderApps, { attributes: true, childList: true, characterData: true, subtree: true });

        const buyButton = section.querySelector('[data-isun-buy-ritual]');
        const status = section.querySelector('[data-isun-buy-ritual-status]');
        buyButton?.addEventListener('click', () => {
          if (buyButton.disabled) return;
          buyButton.disabled = true;
          buyButton.setAttribute('aria-busy', 'true');
          status.textContent = '';
          document.dispatchEvent(new CustomEvent('isun:ritual:buy-complete', {
            detail: { button: buyButton, status }
          }));
        });
      });
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
